<template>
    <v-row>
        <v-col cols="12">
            <div class="title-label">
                {{ $t('entrance.place_of_training') }}
            </div>
            <div class="label">
                {{ $t('entrance.subtext_place') }}
            </div>
        </v-col>
        <v-col cols="12">
            <v-item-group v-model="selectedPlace" multiple>
                <v-row>
                    <v-col v-for="(item, i) in places" :key="i" cols="12">
                        <v-item v-slot:default="{ active, toggle }">
                            <v-img
                                eager v-ripple
                                :src="item.src"
                                gradient="rgba(255,255,255,.4), rgba(255,255,255,.4)"
                                style="border-radius: 4px"
                                @click="toggle"
                            >
                                <v-btn icon class="btn-icon">
                                    <v-icon>{{ active ? 'mdi-square-rounded' : 'mdi-crop-square' }}</v-icon>
                                </v-btn>
                                <div class="bottom-label">
                                    {{ item.name }}
                                </div>
                            </v-img>
                        </v-item>
                    </v-col>
                </v-row>
            </v-item-group>
        </v-col>
    </v-row>
</template>

<script>

import {mapActions, mapState} from 'vuex'

export default {
    data() {
        return {
            selectedPlace: [],
        }
    },
    computed: {
        ...mapState(['config']),
        places(vm = this) {
            if (!vm.config) return []
            return vm.config.places.map(place => ({name: place.name, value: place.name, src: place.src}))
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadPlaces()
    },
    methods: {
        ...mapActions(['bindConfig']),
        loadPlaces() {
            const vm = this
            const places = vm.places.map(place => place.name)
            let myPlaces = []
            vm.account?.places?.forEach(place => {
                myPlaces.push(places.indexOf(place))
            })
            vm.selectedPlace = myPlaces
        }
    },
    watch: {
        account() {
            this.loadPlaces()
        },
        selectedPlace(val) {
            this.$emit('change', val.map(place => this.places[place].name))
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}

.label {
    font-size: 15px;
    color: #707070;
    margin-top: 8px;
    line-height: 20px;
}

.btn-icon {
    position: absolute;
    left: 5%;
    top: 5%;
}

.bottom-label {
    position: absolute;
    left: 5%;
    bottom: 10%;
    font-size: 17px;
    line-height: 22px;
    font-weight: bold;
    color: #161616;
}

</style>